import { PhoneTypes } from '@acceligentllc/shared/enums/contactMethodType';
import { Month } from '@acceligentllc/shared/enums/month';
import { TimePeriodRecent } from '@acceligentllc/shared/enums/timePeriodRecent';
import { WorkRequestStatus } from '@acceligentllc/shared/enums/workRequestStatus';

const uiLabels = {
	MONTH: {
		[Month.JANUARY]: 'January',
		[Month.FEBRUARY]: 'February',
		[Month.MARCH]: 'March',
		[Month.APRIL]: 'April',
		[Month.MAY]: 'May',
		[Month.JUNE]: 'June',
		[Month.JULY]: 'July',
		[Month.AUGUST]: 'August',
		[Month.SEPTEMBER]: 'September',
		[Month.OCTOBER]: 'October',
		[Month.NOVEMBER]: 'November',
		[Month.DECEMBER]: 'December',
	},
	TIME_SPAN: {
		[TimePeriodRecent.YESTERDAY]: 'YESTERDAY',
		[TimePeriodRecent.LAST_WEEK]: 'LAST WEEK',
		[TimePeriodRecent.LAST_MONTH]: 'LAST MONTH',
	},
	STATUS: {
		[WorkRequestStatus.ACCEPTED]: 'Accepted',
		[WorkRequestStatus.COMPLETE]: 'Complete',
		[WorkRequestStatus.ESTIMATE]: 'Estimate',
		[WorkRequestStatus.REJECTED]: 'Rejected',
		[WorkRequestStatus.REQUEST]: 'Request',
		[WorkRequestStatus.REVIEW]: 'Review',
		[WorkRequestStatus.SUBMITTED]: 'Submitted',
		[WorkRequestStatus.FINISHED]: 'Finished',
		[WorkRequestStatus.IN_PROGRESS]: 'In Progress',
		[WorkRequestStatus.SHORT_CIRCUITED]: 'In Progress',
	},
	PHONE_TYPES: {
		[PhoneTypes.PHONE_DIRECT]: 'Direct',
		[PhoneTypes.PHONE_FAX]: 'Fax',
		[PhoneTypes.PHONE_MOBILE]: 'Mobile',
		[PhoneTypes.PHONE_OFFICE]: 'Office',
	},
};

export default uiLabels;
